import React from "react";
import cx from "classnames";
import { ChevronLeftIcon, ChevronRightIcon } from "assets";
import ProfileButton from "pages/Profile/components/common/ProfileButton";
import "./styles.scss";

interface Props {
  direction: "prev" | "next";
  className?: string;
  onClick?: () => void;
}

const SlideButton = ({ onClick, direction, className }: Props) => {
  return (
    <ProfileButton className={cx("slide-button", className)} onClick={onClick}>
      {direction === "prev" ? <ChevronLeftIcon /> : <ChevronRightIcon />}
    </ProfileButton>
  );
};

export default SlideButton;
